import React from 'react'
import { connect } from 'react-redux'
import ModalCalendar from '../components/modal-calendar'

const mapStateToProps = (state) => ({
  ...state.modalCalendar,
  fieldsData: state.calendar.fieldsData,
  minTime: state.calendar.minTime,
  maxTime: state.calendar.maxTime,
  date: state.calendar.initialDate
})

const mapDispatchToProps = dispatch => ({
  onDateChange: payload => dispatch({type: 'MODAL_CALENDAR.DATE_CHANGE', payload}),
  onEventSelect: payload => dispatch({type: 'MODAL_CALENDAR.EVENT_SELECT', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalCalendar)
